import {
  faExclamationTriangle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useCreateGroupMutation } from "../../../services/thoughtSpotV1";

interface MakeNewGroupProps {
  orgId: number;
  tsAccessToken: string;
  creationCallback: () => any;
}

interface MakeNewGroupState {
  openMenu: boolean;
  name: string;
  description: string;
  enableSaveButton: boolean;
  loading: boolean;
  error: {
    errorFlag: boolean;
    errorMessage: string;
  };
}

export const MakeNewGroup = (props: MakeNewGroupProps) => {
  const [state, setState] = useState<MakeNewGroupState>({
    openMenu: false,
    name: "",
    description: "",
    enableSaveButton: false,
    loading: false,
    error: { errorFlag: false, errorMessage: "" },
  });

  const [createGroupQuery, createGroupQueryResults] = useCreateGroupMutation();

  useEffect(() => {
    if (state.name !== "") {
      setState({ ...state, enableSaveButton: true });
    } else {
      setState({ ...state, enableSaveButton: false });
    }
  }, [state.name]);

  const saveGroup = async () => {
    setState({ ...state, enableSaveButton: false, loading: true });
    createGroupQuery({
      thoughtSpotAccessToken: props.tsAccessToken,
      description: state.description,
      groupName: state.name,
      groupDisplayName: state.name,
    });
  };

  useEffect(() => {
    if (
      createGroupQueryResults.isSuccess &&
      createGroupQueryResults.status === "fulfilled"
    ) {
      setState({
        ...state,
        enableSaveButton: true,
        loading: false,
        openMenu: true,
        name: "",
        description: "",
      });
      props.creationCallback && props.creationCallback();
    } else {
      if (createGroupQueryResults.isError) {
        switch ((createGroupQueryResults.error as any).status) {
          case 409:
            setState({
              ...state,
              enableSaveButton: true,
              loading: false,
              openMenu: true,
              error: {
                errorFlag: true,
                errorMessage:
                  "The name of the group should be unique. Please choose another name for the group.",
              },
            });
            break;
          default:
            setState({
              ...state,
              enableSaveButton: true,
              loading: false,
              openMenu: true,
              error: {
                errorFlag: true,
                errorMessage:
                  "The application has encountered an internal error. Please try again later.",
              },
            });
            break;
        }
      }
    }
  }, [createGroupQueryResults]);

  return (
    <div className="mt-2" style={{ margin: "10" }}>
      {state.loading && (
        <div className="module-loading">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!state.loading && (
        <>
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <button
                  className="btn me-2"
                  onClick={() =>
                    setState({ ...state, openMenu: !state.openMenu })
                  }
                >
                  {state.openMenu ? "X" : "V"}
                </button>
                <h5
                  className="card-title mb-0"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setState({ ...state, openMenu: !state.openMenu })
                  }
                >
                  Add Group
                </h5>
              </div>
              <div
                className="card-text"
                style={{ display: state.openMenu ? "block" : "none" }}
              >
                <div>
                  Name:
                  <input
                    type="text"
                    className={
                      !state.error.errorFlag
                        ? "form-control"
                        : "form-control input-error"
                    }
                    value={state.name}
                    onChange={(e) => {
                      setState({
                        ...state,
                        name: e.target.value,
                        error: { errorFlag: false, errorMessage: "" },
                      });
                    }}
                  />
                </div>
                <div>
                  Description:
                  <input
                    type="text"
                    className="form-control"
                    value={state.description}
                    onChange={(e) => {
                      setState({ ...state, description: e.target.value });
                    }}
                  />
                </div>
                {state.error.errorFlag && (
                  <div className="alert alert-danger mt-2">
                    <div className="input-inline-error-message">
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="me-1"
                      />
                      Error: {state.error.errorMessage}
                    </div>
                  </div>
                )}
                <div style={{ paddingTop: "5px" }}>
                  <button
                    className="btn btn-primary"
                    style={{ width: "100px" }}
                    disabled={!state.enableSaveButton}
                    onClick={() => saveGroup()}
                  >
                    {state.enableSaveButton ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
